import { produce } from 'immer';
import { has, keys, isEmpty } from 'lodash';
import { ACTIONS } from '../actions/database.actions';

const initialState = {
    authUser: {},
    companies: {},
    cruiseLines: {},
    cruiseLineIncludes: {},
    cruiseLineItineraries: {},
    cruiseLinePhotos: {},
    cruiseLinePorts: {},
    cruiseLineSailings: {},
    cruiseLineSailingDocuments: {},
    cruiseLineShips: {},
    emailTemplates: {},
    currencies: {},
    insurances: {},
    destinations: {},
    destinationDocuments: {},
    externalIdentifiers: {},
    hotels: {},
    hotelRatePlans: {},
    memberCreditCardDescriptions: {},
    memberAssistants: {},
    memberReports: {},
    memberEmails: {},
    memberPhones: {},
    members: {},
    memberTrips: {},
    memberRewards: {},
    memberRewardComponents: {},
    oauthAccessTokens: {},
    oauthClients: {},
    oauthClientRedirectUrls: {},
    packageOffers: {},
    packageOfferServices: {},
    paymentMethods: {},
    paymentProcesses: {},
    paymentGatewayProfiles: {},
    refunds: {},
    requests: {},
    requestDocuments: {},
    requestQuotes: {},
    requestQuoteComponents: {},
    reservationCancellationApprovals: {},
    reservationCancellationNumbers: {},
    reservationComponentHistories: {},
    reservations: {},
    reservationCruises: {},
    reservationCruiseCabins: {},
    reservationCruiseNumbers: {},
    reservationDocuments: {},
    reservationFlights: {},
    reservationFlightNumbers: {},
    reservationFlightLegs: {},
    reservationHotels: {},
    reservationHotelNumbers: {},
    reservationHotelRooms: {},
    reservationInformativeInvoices: {},
    reservationInsurances: {},
    reservationInsuranceNumbers: {},
    reservationInvoices: {},
    reservationMembers: {},
    reservationRelations: {},
    reservationTransactions: {},
    reservationTransactionLogs: {},
    reservationTransactionComponents: {},
    reservationServices: {},
    reservationServiceNumbers: {},
    roles: {},
    transactionTemplates: {},
    transactionTemplateComponents: {},
    travelAgencies: {},
    travelerPreferences: {},
    users: {},
    userTemplates: {},
    vendors: {},
    vendorServices: {},
    zinrelos: {},
};

export default function (st, action)
{
    const state = isEmpty(st) ? initialState : st;

    return produce(state, (draft) =>
    {
        switch (action.type)
        {
            case ACTIONS.DELETE:
                if (has(draft, `${action.payload.key}.${action.payload.id}`))
                {
                    delete draft[action.payload.key][action.payload.id];
                }
                break;
            case ACTIONS.PUT:
                keys(draft).forEach((key) =>
                {
                    let mergedPayloadControl = action.payload.database[key];
                    if (action.payload.database[key])
                    {
                        mergedPayloadControl = Object.keys(action.payload.database[key]).reduce((obj, item) => ({ ...obj, [item]: { ...draft[key][item], ...action.payload.database[key][item] } }), {});
                    }

                    if (has(action, `payload.database.${key}`)) draft[key] = { ...draft[key], ...mergedPayloadControl };
                });
                break;
            default:
                break;
        }
    });
}
